import React from 'react';
import { Redirect, Route, Switch, useHistory, useLocation, useRouteMatch } from 'react-router-dom';
import PageWrapper from '../PageWrapper';
import SubNavbar from '../../components/Navbar/SubNavbar';
import ButtonBlue from '../../components/Button/ButtonBlue';
import Journal from './Journal';
import Artefacts from './Artefacts';
import NewPost from '../AddPost/AddPost'
import { cssNumber } from 'jquery';
import PostEditor from './PostEditor';
import ViewPastReviews from './ViewPastReviews';
import Button from '../../components/Button/Button';

const JournalPages = (props) => {
    const { path } = useRouteMatch();
    const location = useLocation();
    const history = useHistory();
    const createNewPost = () => {
        history.push(`${path}/new`, { src: location.pathname, valueId: props?.location?.state?.valueId, journal: true });
    }

    return (
        <PageWrapper>
            <div className='cardBackgroundColor border20px shadow-md  md:mt-4 md:mb-6  mt-1 mb-3'>
                {(location.pathname !== `${path}/new`) && (!location.pathname.includes(`${path}/edit`)) && (!location.pathname.includes(`${path}/edit/:postId/pastreviewhistory`)) &&
                    <SubNavbar
                        menuLinks={[
                            { title: 'Journal', url: path, count: null },
                            { title: 'Artefacts', url: `${path}/artefacts`, count: null },
                        ]}
                        aside={<ButtonBlue onClick={createNewPost} title={'+ Add Post'} />}
                    />
                }
                <Switch>
                    <Route exact path={path} component={Journal} />
                    <Route path={`${path}/artefacts`} component={Artefacts} />
                    <Route path={`${path}/edit/:postId/pastreviewhistory`} component={ViewPastReviews} />
                    <Route path={`${path}/new/:postId`} component={PostEditor} />
                    <Route path={`${path}/new`} component={PostEditor} />
                    <Route path={`${path}/edit/:postId`} component={PostEditor} />
                    <Redirect to={{
                        pathname: "/page-not-found",
                        state: { error: true }
                    }} />
                </Switch>
            </div>
        </PageWrapper>

    )
}

export default JournalPages;